import { render, staticRenderFns } from "./UpdatePromoCodeModal.vue?vue&type=template&id=245d7524&scoped=true&"
import script from "./UpdatePromoCodeModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePromoCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePromoCodeModal.vue?vue&type=style&index=0&id=245d7524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d7524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
